<template>
	<div class="card">
		<div class="card-header">
			Sesi WhatsApp
			<el-tooltip placement="right" content="Kelola sesi WhatsApp">
				<el-button link type="primary" tag="router-link" to="wa">
					<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
				</el-button>
			</el-tooltip>
		</div>
		<div class="card-body d-flex justify-content-center" v-loading="loading">
			<div class="text-center">
				<transition name="fade" mode="out-in">
					<span :key="sessionStatus" :class="customClass">
						{{ sessionStatus }}
					</span>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "WaSessions",
	data() {
		return {
			sessions: [],
			sessionStatus: "Memuat...",
			customClass: "",
			loading: true,
		};
	},
	components: {},
	computed: {},
	watch: {},
	mounted() {
		this.$ws.main.on("wa:status", this.updatedSession);
		this.$ws.main.on("session_wa:inserted", this.updatedSession);
		this.$ws.main.on("session_wa:deleted", this.updatedSession);
		this.getSessions();
	},
	beforeUnmount() {
		this.$ws.main.off("wa:status");
		this.$ws.main.off("session_wa:inserted");
		this.$ws.main.off("session_wa:deleted");
	},
	methods: {
		insertedSession(data) {
			this.sessions.push(data);
			this.countSessions();
		},
		updatedSession(data) {
			let isExist = false;
			for (const s of this.sessions) {
				if (s.session_wa_id === data.session_wa_id) {
					isExist = true;
					s.status = data.status;
					break;
				}
			}

			if (!isExist) {
				this.sessions.push(data);
			}

			this.countSessions();
		},
		deletedSession(data) {
			const index = this.sessions.findIndex((s) => s.session_wa_id === data.session_wa_id);

			if (index !== -1) {
				this.sessions.splice(index, 1);
				this.countSessions();
			}
		},
		async getSessions() {
			try {
				const { data } = await this.$defaultApi.get("/wa/count");
				this.sessions = data.data.session_wa_statuses;
				setTimeout(() => {
					this.countSessions();
					this.loading = false;
				}, 500);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
				this.loading = false;
			}
		},
		countSessions() {
			const sessionCount = this.sessions?.length;
			const sessionReady = this.sessions?.filter((s) => s.status === "ready").length;
			if (sessionCount === 0) {
				this.sessionStatus = "Akun WhatsApp tidak ditemukan";
				this.customClass = "fst-italic text-muted";
			} else if (sessionReady === 0) {
				this.sessionStatus = `Belum ada sesi yang siap digunakan dari ${sessionCount} akun yang ada`;
				this.customClass = "text-danger";
			} else if (sessionReady === sessionCount) {
				this.sessionStatus = `${sessionCount} akun WhatsApp siap digunakan`;
				this.customClass = "text-success";
			} else if (sessionReady < sessionCount) {
				this.sessionStatus = `${sessionReady} dari ${sessionCount} akun WhatsApp siap digunakan`;
				this.customClass = "text-warning";
			}
		},
	},
};
</script>

<style scoped></style>
